import React from 'react'
import Icofont from 'react-icofont';
import { Alert } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { removeAlert } from 'src/reducer/action/alert';

export const AlertCommon = () => {

    const dispatch = useDispatch();
    const { alert } = useSelector(state => state.alert);

    const getColor = (color) => {

        switch (color) {
            case 'danger':
                return '#FDEDED'
            case 'success':
                return '#EDF7ED';
            case 'warning':
                return '#FFF4E5';
            case 'info':
                return '#E5F6FD';
            default:
                return '';
        }

    }
    return (
        <Alert
            show={alert?.color || false ? true : false}
            variant={alert?.color || ''}
            onClose={() => dispatch(removeAlert())}
            style={{
                background: getColor(alert?.color),
                borderRadius: '15px'
            }}
            className='border-0'
            dismissible
        >
            <Icofont
                icon={`${alert?.color === 'success' ? 'check-circled' : 'warning'}`}
                className='shadow rounded-circle' />
            &nbsp;
            {alert?.message}
        </Alert>
    )
}


// AlertCommon.propTypes = {
//     data: PropTypes.array,
//     columns: PropTypes.array,
//     debug: PropTypes.bool
// }